<template>
  <div id="data-list-list-view" class="data-list-container vs-con-loading__container" style="margin-top: -15px">
    <div class="show-xs hide-sm mt-2 mb-2"></div>
    <vs-row>
      <vs-col vs-lg="3" vs-xs="12" class="flex flex-col" style="padding-left: 0; gap: 10px">
        <!-- Vehicle Image Container -->
        <vx-card>
          <template slot="no-body">
            <div class="relative" style="padding-top: 10px">
              <!--"Bus", "Passanger", "Truck"-->
              <!-- <div class="absolute" style="top: 10px; right: 10px">
                <vs-button
                  radius
                  color="danger"
                  type="filled"
                  icon="sync_problem"
                  class="p-0"></vs-button>
              </div> -->
              <img :src="!vehicle_category ||
                vehicle_category == '' ||
                vehicle_category == 'Passanger'
                ? icons.FMSTruck
                : vehicle_category == 'Bus'
                  ? icons.FMSBus
                  : icons.FMSTruck
                " alt="" class="mt-2 box-vehicle" style="width: 60%; border-radius: 15px; margin: auto" />
            </div>
          </template>
        </vx-card>

        <!-- Vehicle Information Container -->
        <vx-card>
          <template slot="no-body">
            <div style="padding: 20px 15px; font-size: 12px" class="info-vehicle vs-con-loading__container">
              <h6 style="color: #e91e63; font-weight: 600; margin-bottom: 12px">{{ $t('Vehicle Information') }}</h6>
              <table style="width: 100%; margin-top: 8px; margin-bottom: 15px; border-spacing: 0 4px">
                <tr v-if="
                  getRolePermission().vehicle_details.vehicle_informations
                    .gps_date
                ">
                  <td style="width: 118px">GPS Date</td>
                  <td>:</td>
                  <td>
                    <strong>{{ selectedLocation.device_time }} WIB</strong>
                  </td>
                </tr>
                <tr v-if="
                  getRolePermission().vehicle_details.vehicle_informations
                    .fleet_group
                ">
                  <td>{{ $t('Fleet Group') }}</td>
                  <td>:</td>
                  <td>
                    <strong>{{ selectedLocation.fleet_group_name }}</strong>
                  </td>
                </tr>
                <tr v-if="
                  getRolePermission().vehicle_details.vehicle_informations
                    .license_plate
                ">
                  <td>{{ $t('License Plate') }}</td>
                  <td>:</td>
                  <td>
                    <strong> {{ selectedLocation.license_plate }} </strong>
                  </td>
                </tr>
                <tr v-if="
                  getRolePermission().vehicle_details.vehicle_informations
                    .imei
                ">
                  <td>IMEI</td>
                  <td>:</td>
                  <td>
                    <strong> {{ selectedLocation.imei }} </strong>
                  </td>
                </tr>
                <tr v-if="
                  getRolePermission().vehicle_details.vehicle_informations
                    .vehicle_model
                ">
                  <td>{{ $t('Vehicle Model') }}</td>
                  <td>:</td>
                  <td>
                    <strong> {{ selectedLocation.vehicle_model }} </strong>
                  </td>
                </tr>
                <tr v-if="
                  getRolePermission().vehicle_details.vehicle_informations
                    .driver_name
                ">
                  <td>{{ $t('Driver Name') }}</td>
                  <td>:</td>
                  <td>
                    <strong> {{ selectedLocation.driver_name }} </strong>
                  </td>
                </tr>
                <tr v-if="
                  getRolePermission().vehicle_details.vehicle_informations
                    .driver_phone
                ">
                  <td>{{ $t('Driver Phone') }}</td>
                  <td>:</td>
                  <td>
                    <strong> {{ selectedLocation.driver_phone }} </strong>
                  </td>
                </tr>
                <tr v-if="
                  getRolePermission().vehicle_details.vehicle_informations
                    .location
                ">
                  <td>Latitude</td>
                  <td>:</td>
                  <td>
                    <strong> {{ selectedLocation.latitude }} </strong>
                  </td>
                </tr>
                <tr v-if="
                  getRolePermission().vehicle_details.vehicle_informations
                    .location
                ">
                  <td>Longitude</td>
                  <td>:</td>
                  <td>
                    <strong> {{ selectedLocation.longitude }} </strong>
                  </td>
                </tr>
                <tr v-if="
                  getRolePermission().vehicle_details.vehicle_informations
                    .location
                ">
                  <td>Google Map</td>
                  <td>:</td>
                  <td>
                    <strong>
                      <a target="_blank" :href="'http://www.google.com/maps/place/' +
                        selectedLocation.latitude +
                        ',' +
                        selectedLocation.longitude
                        ">Show Google Map</a>
                    </strong>
                  </td>
                </tr>
                <tr v-if="
                  getRolePermission().vehicle_details.vehicle_informations
                    .location
                ">
                  <td>Street View</td>
                  <td>:</td>
                  <td>
                    <strong>
                      <a target="_blank" :href="'https://www.google.com/maps?q&layer=c&cbll=' +
                        selectedLocation.latitude +
                        ',' +
                        selectedLocation.longitude +
                        '&cbp'
                        ">Show Sreet View</a>
                    </strong>
                  </td>
                </tr>
              </table>
            </div>
          </template>
        </vx-card>

        <!-- Vehicle Status Container -->
        <vx-card v-if="tabIndex != 4">
          <template slot="no-body">
            <div style="padding: 20px 15px; font-size: 12px" class="status-vehicle vs-con-loading__container">
              <h6 id="vstatus-header" style="color: #e91e63; font-weight: 600; margin-bottom: 12px">{{ $t('Vehicle Status') }}</h6>
                <table style="width: 100%; margin-top: 8px; border-spacing: 0 4px">
                  <tr v-if="
                    getRolePermission().vehicle_details.vehicle_status
                      .event_name
                  ">
                    <td style="width: 118px">{{ $t('Event Name') }}</td>
                    <td>:</td>
                    <td>
                      <strong>{{ selectedLocation.event_type }}</strong>
                    </td>
                  </tr>
                  <tr v-if="
                    getRolePermission().vehicle_details.vehicle_status.speed
                  ">
                    <td>{{ $t('Speed') }}</td>
                    <td>:</td>
                    <td>
                      <strong>{{ selectedLocation.speed }} km/jam</strong>
                    </td>
                  </tr>
                  <tr v-if="
                    getRolePermission().vehicle_details.vehicle_status
                      .read_odometer
                  ">
                    <td>Total Odometer</td>
                    <td>:</td>
                    <td>
                      <strong>
                        {{ commafy(selectedLocation.total_odometer / 1000) }}
                        KM
                      </strong>
                    </td>
                  </tr>
                  <tr v-if="
                    getRolePermission().vehicle_details.vehicle_status
                      .tms_odometer
                  ">
                    <td>TMS Odometer</td>
                    <td>:</td>
                    <td>
                      <strong>
                        {{ commafy(selectedLocation.tms_odometer / 1000) }}
                        KM
                      </strong>
                    </td>
                  </tr>
                  <tr v-if="
                    getRolePermission().vehicle_details.vehicle_status
                      .tms_deviasi_odometer
                  ">
                    <td>Deviasi Odometer</td>
                    <td>:</td>
                    <td>
                      <strong class="mr-3">
                        {{ selectedLocation.tms_deviasi_odometer }}
                      </strong>
                      <!-- <vs-button
                        v-if="
                          getRolePermission().vehicle_details.vehicle_status
                            .kalibrasi_odometer
                        "
                        color="danger"
                        type="border"
                        size="small"
                        @click="
                          () => {
                            openCalibrate = true
                            odometer_calibration =
                              selectedLocation.tms_odometer / 1000
                          }
                        "
                        >Kalibrasi Odometer</vs-button
                      > -->
                      <vs-popup :active.async="openCalibrate" @close="openCalibrate = false" title="Kalibrasi Odometer">
                        <div class="">
                          <label for="" style="width: 600px">Set Odometer (KM)<sup>*</sup></label>
                          <vs-input data-vv-validate-on="blur" v-validate="'required|min:1|max:15'" type="number"
                            name="odometer_calibration" v-model="odometer_calibration" class="w-full no-icon-border" />
                          <div class="flex flex-row mt-5" style="gap: 15px">
                            <vs-button color="danger" type="border" class="w-full font-bold"
                              @click="openCalibrate = false">Cancel</vs-button>
                            <vs-button color="danger" class="w-full font-bold" @click="setCalibration()">Set</vs-button>
                          </div>
                        </div>
                      </vs-popup>
                    </td>
                  </tr>
                  <tr v-if="
                    getRolePermission().vehicle_details.vehicle_status
                      .tms_last_update
                  ">
                    <td>Last Update TMS</td>
                    <td>:</td>
                    <td>
                      <strong>
                        {{ selectedLocation.tms_last_update }}
                      </strong>
                    </td>
                  </tr>
                  <tr v-if="
                    getRolePermission().vehicle_details.vehicle_status.fuel
                  ">
                    <td>{{ $t('Fuel') }}</td>
                    <td>:</td>
                    <td>
                      <strong>{{ selectedLocation.fuel_level_1_x }} %</strong>
                    </td>
                  </tr>
                  <tr v-if="
                    getRolePermission().vehicle_details.vehicle_status
                      .direction
                  ">
                    <td>{{ $t('Direction') }}</td>
                    <td>:</td>
                    <td>
                      <strong>
                        {{ selectedLocation.direction
                        }}<sup style="color: black">0</sup>
                      </strong>
                    </td>
                  </tr>
                  <tr v-if="
                    getRolePermission().vehicle_details.vehicle_status
                      .internal_battery
                  ">
                    <td>{{ $t('Internal Battery') }}</td>
                    <td>:</td>
                    <td>
                      <strong>
                        {{
                          formatDecimal(
                            selectedLocation.internal_battery_voltage
                          )
                        }}
                        V
                      </strong>
                    </td>
                  </tr>
                  <tr v-if="
                    getRolePermission().vehicle_details.vehicle_status
                      .external_battery
                  ">
                    <td>{{ $t('External Battery') }}</td>
                    <td>:</td>
                    <td>
                      <strong>
                        {{
                          formatDecimal(selectedLocation.external_power_voltage)
                        }}
                        V
                      </strong>
                    </td>
                  </tr>
                  <tr v-if="
                    getRolePermission().vehicle_details.vehicle_status
                      .engine_temp
                  ">
                    <td>{{ $t('Engine Temp') }}</td>
                    <td>:</td>
                    <td>
                      <strong>
                        {{
                          checkSuhu(
                            selectedLocation.engine_coolant_temperature_x
                          )
                        }}
                        <sup style="color: black">0</sup>C
                      </strong>
                    </td>
                  </tr>
                  <tr v-if="
                    getRolePermission().vehicle_details.vehicle_status
                      .chiller_temp && temperature_module
                  ">
                    <td>{{ $t('Chiller Temp 1') }}</td>
                    <td>:</td>
                    <td>
                      <strong>
                        {{ formatFloat(selectedLocation.dallas_temperature_1) }}
                        <sup style="color: black">0</sup>C</strong>
                    </td>
                  </tr>
                  <tr v-if="
                    getRolePermission().vehicle_details.vehicle_status
                      .chiller_temp && temperature_module
                  ">
                    <td>{{ $t('Chiller Temp 2') }}</td>
                    <td>:</td>
                    <td>
                      <strong>
                        {{ formatFloat(selectedLocation.dallas_temperature_2) }}
                        <sup style="color: black">0</sup>C</strong>
                    </td>
                  </tr>
                  <tr v-if="
                    getRolePermission().vehicle_details.vehicle_status
                      .humidity
                  ">
                    <td>{{ $t('Humidity') }}</td>
                    <td>:</td>
                    <td>
                      <strong>
                        {{ formatFloat(selectedLocation.humidity) }} %
                      </strong>
                    </td>
                  </tr>
                  <tr v-if="
                    getRolePermission().vehicle_details.vehicle_status
                      .battery_level
                  ">
                    <td>{{ $t('Battery Level (eye sensor)') }}</td>
                    <td>:</td>
                    <td>
                      <strong>
                        {{ formatFloat(selectedLocation.humidity) }} %
                      </strong>
                    </td>
                  </tr>
                  <tr v-if="
                    getRolePermission().vehicle_details.vehicle_status.rpm
                  ">
                    <td>RPM</td>
                    <td>:</td>
                    <td>
                      <strong>
                        {{ selectedLocation.engine_speed_x }} rpm</strong>
                    </td>
                  </tr>

                  <tr v-if="
                    getRolePermission().vehicle_details.vehicle_status
                      .engine_status
                  ">
                    <td>{{ $t('Engine Status') }}</td>
                    <td>:</td>
                    <td>
                      <span v-if="selectedLocation.ignition == 0" style="color: red">
                        <strong>OFF</strong>
                      </span>
                      <span v-if="selectedLocation.ignition == 1" style="color: green">
                        <strong> ON</strong>
                      </span>
                    </td>
                  </tr>
                  <tr v-if="
                    getRolePermission().vehicle_details.vehicle_status.sos
                  ">
                    <td>SOS</td>
                    <td>:</td>
                    <td>
                      <span v-if="checkStatus('panic', 'ON')" style="color: red"><strong> ON </strong></span>
                      <span v-if="checkStatus('panic', 'OFF')" style="color: green"><strong> OFF </strong></span>
                      <span v-if="checkStatus('panic', '')"><strong> - </strong></span>
                    </td>
                  </tr>

                  <tr v-if="
                    getRolePermission().vehicle_details.vehicle_status
                      .door_status
                  ">
                    <td>{{ $t('Left Door') }}</td>
                    <td>:</td>
                    <td>
                      <span v-if="checkStatus('dleft', 'OPEN')" style="color: red"><strong> OPEN </strong></span>
                      <span v-if="checkStatus('dleft', 'CLOSED')" style="color: green"><strong> CLOSE </strong></span>
                      <span v-if="checkStatus('dleft', '')"><strong> - </strong></span>
                    </td>
                  </tr>

                  <tr v-if="
                    getRolePermission().vehicle_details.vehicle_status
                      .door_status
                  ">
                    <td>{{ $t('Right Door') }}</td>
                    <td>:</td>
                    <td>
                      <span v-if="checkStatus('dright', 'OPEN')" style="color: red"><strong> OPEN </strong></span>
                      <span v-if="checkStatus('dright', 'CLOSED')" style="color: green"><strong> CLOSE </strong></span>
                      <span v-if="checkStatus('dright', '')"><strong> - </strong></span>
                    </td>
                  </tr>
                  <tr v-if="
                    getRolePermission().vehicle_details.vehicle_status
                      .door_status
                  ">
                    <td>{{ $t('Rear Door') }}</td>
                    <td>:</td>
                    <td>
                      <span v-if="checkStatus('drear', 'OPEN')" style="color: red"><strong> OPEN </strong></span>
                      <span v-if="checkStatus('drear', 'CLOSED')" style="color: green"><strong> CLOSE </strong></span>
                      <span v-if="checkStatus('drear', '')"><strong> - </strong></span>
                    </td>
                  </tr>
                  <tr v-if="
                    getRolePermission().vehicle_details.vehicle_status.fatigue
                  ">
                    <td>{{ $t('Fatigue') }}</td>
                    <td>:</td>
                    <td>
                      <span v-if="checkStatus('fcamera', 'ON')" style="color: red"><strong> ON </strong></span>
                      <span v-if="checkStatus('fcamera', 'OFF')" style="color: green"><strong> OFF </strong></span>
                      <span v-if="checkStatus('fcamera', '')"><strong> - </strong></span>
                    </td>
                  </tr>
                </table>
            </div>
          </template>
        </vx-card>

        <!-- RITASE -->
        <vx-card v-if="tabIndex == 4" style="max-height: 390px; overflow-y: scroll">
          <template slot="no-body">
            <!-- Loop this -->
            <RitationItem v-if="ritations._id" :isGeo="true" type="geofence_out" :item="ritations.geofence_out" />
            <div v-else class="p-10">No Ritation Data Available</div>
            <RitationItem v-if="ritations._id" v-for="(item, i) in ritations.poi_loading" :key="i" :item="item" />
            <RitationItem v-if="ritations._id && ritations.arrival_date_time" type="geofence_in" :isGeo="true" :isGeoEnd="true"
              :item="ritations.geofence_in" />
          </template>
        </vx-card>
      </vs-col>
      <vs-col vs-lg="9" vs-xs="12" style="padding-right: 0">
        <!-- Tab Switcher Container -->
        <vx-card class="mb-3">
          <template slot="no-body">
            <div style="padding: 15px 20px;">
              <vs-tabs :value="tabIndex">
                <vs-tab v-if="
                  getRolePermission().vehicle_details.main_feature.overviews
                " label="Overview" @click="tabIndex = 0">
                </vs-tab>
                <vs-tab v-if="
                  getRolePermission().vehicle_details.main_feature.live_track
                " label="Live Track" @click="tabIndex = 1">
                </vs-tab>
                <vs-tab v-if="
                  getRolePermission().vehicle_details.main_feature
                    .periodic_track
                " label="Periodic Track" @click="tabIndex = 2">
                </vs-tab>
                <vs-tab v-if="
                  getRolePermission().vehicle_details.main_feature
                    .historical_trip
                " label="Historical Trip" @click="tabIndex = 3">
                </vs-tab>
                <vs-tab v-if="getRolePermission().vehicle_details.main_feature.timeline" label="Timeline"
                  @click="tabIndex = 4">
                </vs-tab>
                <vs-tab v-if="getRolePermission().vehicle_details.main_feature.commands" label="Commands"
                  @click="tabIndex = 5">
                </vs-tab>
                <vs-tab v-if="
                  dashcam &&
                  getRolePermission().vehicle_details.main_feature.live_cam
                " label="Live Cam" @click="tabIndex = 6">
                </vs-tab>
                <vs-tab v-if="
                  dashcam &&
                  getRolePermission().vehicle_details.main_feature.dashcam_alert
                " label="Dashcam Alert" @click="tabIndex = 7">
                </vs-tab>
                <vs-tab v-if="
                  dashcam &&
                  getRolePermission().vehicle_details.main_feature.dashcam_alert
                " label="Dashcam Playback" @click="tabIndex = 8">
                </vs-tab>
                <vs-tab label="Immobilization" @click="navigateImmo()" v-if="activeImo">
                </vs-tab>
              </vs-tabs>
            </div>
          </template>
        </vx-card>

        <!-- Select Type and Refresh Container (for Overview tab only) -->
        <vx-card v-if="tabIndex == 0" class="mb-3">
          <template slot="no-body">
            <div style="padding: 15px 20px; position: relative;">
              <div class="vs-component vs-con-input-label vs-input mb-1 vs-input-primary">
                <v-select style="width: 350px" placeholder="- Select Event Type -"
                  @input="(x) => (event_type = x.value)" :clearable="false"
                  :value="getSelectValue(event_type, event_list)" :reduce="(text) => text.value" label="text"
                  :options="event_list" />
              </div>
              <div @click="getOverview()" class="shadow" style="
                  border-radius: 7px;
                  z-index: 2;
                  background: #2f3191;
                  position: absolute;
                  right: 25px;
                  top: 15px;
                  cursor: pointer;
                  padding: 4px;
                ">
                <feather-icon style="color: #f1fff1" icon="RefreshCwIcon" svgClasses="h-8 w-8" class="float-left" />
              </div>
            </div>
          </template>
        </vx-card>

        <!-- Data Content Container - Overview Tab -->
        <div v-if="tabIndex == 0" class="overviews-cont vs-con-loading__container">
          <!-- Each data item in its own vx-card -->
          <vx-card v-for="(tr, indextr) in paginatedOverview" :key="indextr" class="mb-3">
            <template slot="no-body">
              <div style="padding: 15px 20px;">
                <vs-row vs-w="12">
                  <vs-col vs-justify="center" vs-align="center" vs-xs="1" vs-lg="1" vs-md="1" vs-sm="1"
                    style="position: relative">
                    <div style="
                        background: #42aeef;
                        border-radius: 50%;
                        width: 50px;
                        height: 50px;
                        top: 50%;
                        transform: translateY(-50%);
                        position: absolute;
                      ">
                      <img :src="icons[tr.event_type]" style="width: 100%" alt="" />
                    </div>
                  </vs-col>
                  <vs-col vs-xs="11" vs-lg="11" vs-md="11" vs-sm="11">
                    <!-- Driver Name (Baris 1) -->
                    <div style="font-weight: 600; font-size: 1rem; color: #1e293b; margin-bottom: 2px;">
                      {{ tr.driver_name ? tr.driver_name : '-' }}
                    </div>
                    
                    <!-- Speed + Date (Baris 2) -->
                    <div style="font-size: 0.85rem; color: #64748b; margin-bottom: 4px;">
                      {{ tr.speed }} KM/H | {{ formatDate(tr.device_time) }} WIB
                    </div>
                    
                    <!-- Address (Baris 3) -->
                    <div style="font-size: 0.85rem; color: #64748b;">
                      <span v-if="tr.address">{{ tr.address }}</span>
                      <span v-else class="loader_1"></span>
                    </div>
                  </vs-col>
                </vs-row>
              </div>
            </template>
          </vx-card>
          
          <!-- Pagination for Overview Tab -->
          <template v-if="overview.length > 0">
            <vs-pagination :total="totalPages" v-model="currentPage"></vs-pagination>
          </template>
        </div>

        <!-- Data Content Container - Other Tabs -->
        <vx-card v-if="tabIndex != 0">
          <template slot="no-body">
            <div style="padding: 20px;">
              
              <!-- Live Track Tab Content -->
              <div v-if="tabIndex == 1">
                <monitoringViewOne :data_s="selectedLocation" :categoryPOI="categoryPOI"
                  :dataSubscribe="dataSubscribe" :license_plate="license_plate"></monitoringViewOne>
              </div>
              
              <!-- Periodic Track Tab Content -->
              <div v-if="tabIndex == 2">
                <monitoringPB :license_plate="license_plate"> </monitoringPB>
              </div>
              
              <!-- Historical Trip Tab Content -->
              <div v-if="tabIndex == 3">
                <MonitoringTrip :license_plate="license_plate">
                </MonitoringTrip>
              </div>
              
              <!-- Timeline Tab Content -->
              <div v-if="tabIndex == 4">
                <MonitoringTimeline :license_plate="license_plate">
                </MonitoringTimeline>
              </div>
              
              <!-- Commands Tab Content -->
              <div v-if="tabIndex == 5">
                <MonitoringCommands :imei="selectedLocation.imei" :odometer="selectedLocation.tms_odometer
                  "></MonitoringCommands>
              </div>
              
              <!-- Live Cam Tab Content -->
              <div v-if="tabIndex == 6">
                <MonitoringCamera :license_plate="license_plate" :dashcam="dashcam"></MonitoringCamera>
              </div>
              
              <!-- Dashcam Alert Tab Content -->
              <div v-if="tabIndex == 7">
                <MonitoringAlertCamera :license_plate="license_plate" :dashcam="dashcam"></MonitoringAlertCamera>
              </div>
              
              <!-- Dashcam Playback Tab Content -->
              <div v-if="tabIndex == 8">
                <MonitoringPlaybackCamera :license_plate="license_plate" :dashcam="dashcam"></MonitoringPlaybackCamera>
              </div>
              
              <!-- Immobilization Tab Content -->
              <div v-if="activeImmo">
                <monitoringImmo :license_plate="license_plate" :vehicle_id="vehicle_id"
                  :simcard_number="simcard_number">
                </monitoringImmo>
              </div>
            </div>
          </template>
        </vx-card>
      </vs-col>
    </vs-row>
    <visualTelemetry :viewTeleModal="viewTeleModal" :vehicle_category="vehicle_category"
      :selectedLocation="selectedLocation" @closeModal="closeModal()">
    </visualTelemetry>
  </div>
  <!--<vs-button class="mr-3 mb-2" @click="submitForm" >Get Data</vs-button>-->
</template>

<script>
import firebase from 'firebase/app'

const car =
  'M17.402,0H5.643C2.526,0,0,3.467,0,6.584v34.804c0,3.116,2.526,5.644,5.643,5.644h11.759c3.116,0,5.644-2.527,5.644-5.644 V6.584C23.044,3.467,20.518,0,17.402,0z M22.057,14.188v11.665l-2.729,0.351v-4.806L22.057,14.188z M20.625,10.773 c-1.016,3.9-2.219,8.51-2.219,8.51H4.638l-2.222-8.51C2.417,10.773,11.3,7.755,20.625,10.773z M3.748,21.713v4.492l-2.73-0.349 V14.502L3.748,21.713z M1.018,37.938V27.579l2.73,0.343v8.196L1.018,37.938z M2.575,40.882l2.218-3.336h13.771l2.219,3.336H2.575z M19.328,35.805v-7.872l2.729-0.355v10.048L19.328,35.805z'
import 'firebase/database'
import * as REPO from '../../repository/index'
//icon

import IconSampling from '../../assets/Icon-baru/AFMS_SAMPLING.png'
import IconCalendar from '../../assets/Icon-baru/AFMS-Calendar.png'
import IconMapLocation from '../../assets/Icon-baru/AFMS-MapLocation.png'
import IconProfileDriver from '../../assets/Icon-baru/AFMS-ProfileDriver.png'
import IconOverTemp from '../../assets/Icon-baru/AFMS_OVERTEMP.png'
import IconHars from '../../assets/Icon-baru/AFMS_HARSH.png'
import IconHarsAcc from '../../assets/Icon-baru/AFMS_HARSH_ACC.png'
import IconHarsBrk from '../../assets/Icon-baru/AFMS_HARSH_BRK.png'
import IconMBCN from '../../assets/Icon-baru/AFMS_MB_CN.png'
import IconOverspeed from '../../assets/Icon-baru/AFMS_OVERSPEED.png'
import IconCrash from '../../assets/Icon-baru/AFMS_CRASH.png'
import IconMBRN from '../../assets/Icon-baru/AFMS_MB_RN.png'
import IconPanicOn from '../../assets/Icon-baru/AFMS_PANIC_ON.png'
import IconPanicOff from '../../assets/Icon-baru/AFMS_PANIC_OFF.png'
import IconFatigueOff from '../../assets/Icon-baru/AFMS_FATIGUE.png'
import IconJADT from '../../assets/Icon-baru/AFMS_JA_DT.png'
import IconDrearOpen from '../../assets/Icon-baru/AFMS_DREAR_OPEN.png'
import IconDrearClose from '../../assets/Icon-baru/AFMS_DREAR_CLOSE.png'
import IconFatigueOn from '../../assets/Icon-baru/AFMS_FATIGUE.png'
import IconDleftOpen from '../../assets/Icon-baru/AFMS_DLEFT_OPEN.png'
import IconDleftClose from '../../assets/Icon-baru/AFMS_DLEFT_CLOSE.png'
import IconMBLWN from '../../assets/Icon-baru/AFMS_MB_LWN.png'
import IconRPMOver from '../../assets/Icon-baru/AFMS_RPM_OVER.png'
import IconBBFN from '../../assets/Icon-baru/AFMS_BB_FN.png'
import IconDrightOpen from '../../assets/Icon-baru/AFMS_DRIGHT_OPEN.png'
import IconDrightClose from '../../assets/Icon-baru/AFMS_DRIGHT_CLOSE.png'
import IconBBLWN from '../../assets/Icon-baru/AFMS_BB_LWN.png'
import IconKeyON from '../../assets/Icon-baru/AFMS_KEY_ON.png'
import IconKeyOFF from '../../assets/Icon-baru/AFMS_KEY_OFF.png'
import IconOverstayOn from '../../assets/Icon-baru/Overstay_Engine_On.png'
import IconOverstayOff from '../../assets/Icon-baru/Overstay_Engine_Off.png'
import { socket, JoinRoom } from '@/socket'

import FMSBus from '../../assets/Icon-baru/FMS-Bus.png'
import FMSPassenger from '../../assets/Icon-baru/FMS-Passenger.png'
import FMSTruck from '../../assets/images/icons/b_log.png'

import geoDot from '../../assets/images/timeline/GeoDot.png'
import poiDot from '../../assets/images/timeline/PoiDot.png'

import { gmapApi } from 'vue2-google-maps'
import * as moment from 'moment'
import monitoringPB from './MonitoringPlayBack.vue'
import monitoringViewOne from './MonitoringViewOne.vue'
import monitoringImmo from './MonitoringImmo.vue'
import MonitoringTrip from './MonitoringTrip.vue'
import MonitoringTimeline from './MonitoringTimeline.vue'
import visualTelemetry from './VisualTelemetry.vue'
import MonitoringCamera from './MonitoringCamera.vue'
import MonitoringAlertCamera from './MonitoringAlertCamera.vue'
import MonitoringPlaybackCamera from './MonitoringPlaybackCamera.vue'
import RitationItem from './RitationItem.vue'
import MonitoringCommands from './MonitoringCommands.vue'

export default {
  components: {
    monitoringPB,
    monitoringViewOne,
    monitoringImmo,
    MonitoringTrip,
    MonitoringTimeline,
    MonitoringCamera,
    MonitoringAlertCamera,
    MonitoringPlaybackCamera,
    MonitoringCommands,
    visualTelemetry,
    RitationItem,
  },
  data() {
    return {
      icons: {
        DRIGHT_OPEN: IconDrightOpen,
        DRIGHT_CLOSE: IconDrightClose,
        DLEFT_OPEN: IconDleftOpen,
        DLEFT_CLOSE: IconDleftClose,
        DREAR_CLOSE: IconDrearClose,
        DREAR_OPEN: IconDrearOpen,
        BB_LWN: IconBBLWN,
        MB_LWN: IconMBLWN,
        BB_FN: IconBBFN,
        RPM_OVER: IconRPMOver,
        MB_CN: IconMBCN,
        FATIGUE_ON: IconFatigueOn,
        JA_DT: IconJADT,
        FATIGUE_OFF: IconFatigueOff,
        PANIC_OFF: IconPanicOff,
        PANIC_ON: IconPanicOn,
        MB_RN: IconMBRN,
        CRASH: IconCrash,
        OVERSPEED: IconOverspeed,
        HARSH_ACC: IconHarsAcc,
        HARSH_BRK: IconHarsBrk,
        HARSH: IconHars,
        OVERTEMP: IconOverTemp,
        IconCalendar: IconCalendar,
        KEY_ON: IconKeyON,
        KEY_OFF: IconKeyOFF,
        SAMPLING: IconSampling,
        IconProfileDriver: IconProfileDriver,
        IconMapLocation: IconMapLocation,
        FMSBus: FMSBus,
        FMSPassenger: FMSPassenger,
        FMSTruck: FMSTruck,
        OVERSTAY_ENGINE_ON: IconOverstayOn,
        OVERSTAY_ENGINE_OFF: IconOverstayOff,
        geoDot: geoDot,
        poiDot: poiDot,
      },
      pesan: '',
      license_plate: '',
      overview: [],
      last_page: 1,
      page: 1,
      vehicle_category: null,
      userFirebase: null,
      activeMonitoring: false,
      activeImmo: false,
      loading_overview: true,
      reff: null,
      reff2: null,
      sub_success: false,
      loading_live: false,
      center: { lat: -6.1498619, lng: 106.882887 },
      location_list: [],
      map: '',
      directionDisplay: '',
      directionsService: '',
      selectedLocation: {},
      stepDisplay: '',
      simcard_number: '',
      vehicle_id: '',
      active_geofence: true,
      activeImo: false,
      viewTeleModal: false,
      lastStep: 50,
      position: '',
      eol: '',
      speed2: '',
      event_list: [],
      event_type: '',
      id: '',
      icon: {},
      polygon: [],
      polySub: [],
      categoryPOI: [],
      dataSubscribe: [],
      lastVertex: 1,
      k: 0,
      stepnum: 0,
      car: 'M17.402,0H5.643C2.526,0,0,3.467,0,6.584v34.804c0,3.116,2.526,5.644,5.643,5.644h11.759c3.116,0,5.644-2.527,5.644-5.644 V6.584C23.044,3.467,20.518,0,17.402,0z M22.057,14.188v11.665l-2.729,0.351v-4.806L22.057,14.188z M20.625,10.773 c-1.016,3.9-2.219,8.51-2.219,8.51H4.638l-2.222-8.51C2.417,10.773,11.3,7.755,20.625,10.773z M3.748,21.713v4.492l-2.73-0.349 V14.502L3.748,21.713z M1.018,37.938V27.579l2.73,0.343v8.196L1.018,37.938z M2.575,40.882l2.218-3.336h13.771l2.219,3.336H2.575z M19.328,35.805v-7.872l2.729-0.355v10.048L19.328,35.805z',
      step: 50,
      tick: 100,
      activePeriodic: false,
      polyline: null,
      speed: 0.000005,
      wait: 1,
      poly2: null,
      infowindow: null,
      timerHandle: null,
      marker: null,
      markerArray: [],
      steps: [],
      tabIndex: 0,
      dashcam: null,
      temperature_module: false,

      openCalibrate: false,
      odometer_calibration: 0,

      ritations: {},

      // Pagination properties
      currentPage: 1,
      itemsPerPage: 8,
    }
  },
  computed: {
    google: gmapApi,
    paginatedOverview() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.overview.slice(start, end);
    },
    totalPages() {
      return Math.ceil(this.overview.length / this.itemsPerPage);
    },
  },
  watch: {
    tabIndex(val) {
      if (val == 4) {
        this.$root.$on('resolveRitationData', (val) => {
          this.ritations = val
        })
      } else {
        this.ritations = {}
      }
    },
    ritations(val) {
      if (this.tabIndex == 4) {
        const getLocGeo = async (geo) => {
          const locGeo = await this.getAddress(val.latitude, val.longitude)
          this.$set(this.ritations[geo], 'address', locGeo.display_name)
        }

        getLocGeo('geofence_in')
        getLocGeo('geofence_out')

        this.$set(this.ritations.geofence_out, 'alerts', val.alert.geofence_out)

        val.poi_loading.forEach(async (x, index) => {
          try {
            const tmp = await this.getAddress(x.latitude, x.longitude)
            //
            this.$set(this.ritations.poi_loading, index, {
              ...x,
              address: tmp.display_name,
              alerts: val.alert.poi_loading[index],
            })
          } catch (err) {
            console.error(err)
            this.$set(this.overview, index, { ...x, address: '' })
          }
        })
      }
    },
    async event_type(val) {
      this.loadingStart('overviews-cont')
      // this.event_type = ''
      let params = {
        sort: 'DESC',
        license_plate: this.license_plate,
        last_track: 1,
        event_type: val
      }

      try {
        const res = await REPO.getPlayback(params)
        this.loading_overview = false

        const data = res.data.data
        if (data.length > 0) {
          this.overview = data

          this.overview.forEach(async (x, index) => {
            try {
              const tmp = await this.getAddress(x.latitude, x.longitude)
              //
              this.$set(this.overview, index, {
                ...x,
                address: tmp.display_name,
              })
            } catch (err) {
              console.error(err)
              this.$set(this.overview, index, { ...x, address: '' })
            }
          })
        } else {
          this.overview = []
          this.$toast.error('Data not found')
        }

        this.loadingStop('overviews-cont')
      } catch (error) {
        console.error(error)
      }
    },
    '$route.params.id': function (val) {
      this.navigateHandler()
      this.$vs.loading({
        container: '#data-list-list-view',
        scale: 1,
      })
      setTimeout(() => {
        // this.reSubscribe()
      }, 300)
    },
    active_geofence(val) {
      // (val);
      if (val == true) {
        if (this.dataSubscribe != '') {
          this.dataSubscribe.forEach((poli) => {
            let poly = []
            poli.geofence_detail.forEach((x) => {
              let tmp = new google.maps.LatLng(x.latitude, x.longitude)
              poly.push(tmp)
            })
            let tmo = new google.maps.Polygon({
              path: poly,
              draggable: false,
              editable: false,
              strokeColor: poli.colour,
              strokeOpacity: 0.8,
              strokeWeight: 2,
              fillColor: poli.colour,
              fillOpacity: 0.35,
              map: this.map,
            })
            this.polygon.push(tmo)
          })
        }
      } else {
        this.polygon.forEach((x) => {
          x.setMap(null)
        })
      }
    },
  },
  created() {
    var self = this
    this.getCategoryPOI()
    this.id = this.$route.params.id
    JoinRoom(this.id)
    socket.addEventListener(this.id, (event) => {
      const data = event.body
      //
      // only replace the selectedLocation attribute where it exist in the data
      this.selectedLocation = {
        ...this.selectedLocation,
        ...data,
      }

      if (!this.activePeriodic && !this.activeMonitoring) {
        this.getOverview()
      }
      // this.getOverview()
    })
    // document.addEventListener('beforeunload', this.CloseHandler)
    // window.addEventListener('beforeunload', function (event) {
    //     self.reff.off();
    //     REPO.unsubscribeVehicle(self.id);
    // }, false)
    window.onbeforeunload = () => {
      // (this.$route.name);
      // ("ok");
      let alamat = this.$route.name
      if (alamat == 'monitoringView') {
        self.closeHandler()

        return 'Some task is in progress. Are you sure, you want to close?'
      } else {
        return undefined
      }
      // setTimeout(()=>{
      //     this.subscribe();
      // },5000);
      // if (this.$route.name === 'monitoringView') {
      //
      //
      // }
    }
  },
  beforeDestroy() {
    this.navigateHandler()
    socket.leave(this.id)
    // REPO.unsubscribeVehicle(this.$route.params.id);
    // ("Before Destroy 2");
  },
  methods: {
    setCalibration() {
      const body = {
        imei: this.selectedLocation.imei,
        odometer: this.odometer_calibration,
      }

      //

      REPO.postCalibrate(body)
        .then((res) => {
          this.$toast.success('Calibration success')
        })
        .catch((err) => {
          this.$toast.error('Calibration failed')
        })
        .finally(() => {
          this.openCalibrate = false
        })
    },
    setHeaderHidden() {
      const vehicle_status =
        this.getRolePermission().vehicle_details.vehicle_status
      // check if all the vehicle details permission is false then hide the header
      const res = !Object.values(vehicle_status).some((value) => value)
      if (res) {
        // setTimeout(() => {
        const head = document.getElementById('vstatus-header')
        head.style.display = 'none'
        // }, 1000)
      }
      // return !Object.values(vehicle_details).some((value) => value)
    },
    commafy(num) {
      if (!num) return num
      num = num.toString().split('.')[0]
      var str = num.toString().split('.')
      if (str[0].length >= 4) {
        str[0] = str[0].replace(/(\d)(?=(\d{3})+$)/g, '$1.')
      }
      if (str[1] && str[1].length >= 5) {
        str[1] = str[1].replace(/(\d{3})/g, '$1 ')
      }
      return str.join('.')
    },
    formatFloat(val) {
      return parseFloat(val).toFixed(1)
    },
    closeModal() {
      this.viewTeleModal = false
    },
    getCategoryPOI() {
      REPO.getListCategoryPOI()
        .then((res) => {
          let tmp = res.data.data
          tmp.forEach((z) => {
            z.active_poi = false
            z.tampil = true
          })
          this.categoryPOI = tmp
        })
        .catch((err) => {
          //
        })
    },
    checkSuhu(val) {
      let tmp = val
      if (parseInt(val) > 99) {
        tmp = Math.round(parseInt(val) / 10)
      }
      return tmp
    },
    format_number(val) {
      if (val) {
        let tmp = Math.round(val)
        return tmp.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
      } else {
        return val
      }
    },
    formatDecimal(val) {
      if (val) {
        let tmp = parseFloat(val)
        return tmp.toFixed(1)
      }
    },
    checkStatus(key, val) {
      let selected = JSON.parse(JSON.stringify(this.selectedLocation))
      //
      if (key in selected) {
        if (selected[key] == val) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    },
    formatDate(val) {
      return moment(val).format('DD MMMM YYYY HH:mm:ss')
    },
    async getAddress(latitude, longitude) {
      const body = {
        lat: latitude,
        lon: longitude,
      }
      let tmp = await REPO.getAddress(body)

      //
      return tmp.data
    },
    loadingStart(val) {
      this.$vs.loading({
        container: `.${val}`,
        scale: 0.45,
      })
    },
    loadingStop(val) {
      this.$vs.loading.close(`.${val} > .con-vs-loading`)
    },
    getOverview() {
      //this.loadingStart('overviews-cont')
      // this.event_type = ''
      let params = {
        sort: 'DESC',
        license_plate: this.license_plate,
        limit: 20,
        last_track: 1,
        event_type: this.event_type
      }

      try {
        //
        const res = REPO.getPlayback(params).then((res) => {
          this.loading_overview = false
          // var startTime = performance.now()

          const data = res.data.data
          //
          if (data.length == 0) {
            //this.loadingStop('overviews-cont')
          }
          //
          this.overview = data
          //this.loadingStop('overviews-cont')

          if (this.tabIndex !== 0) {
            return
          } else {
            this.overview.forEach(async (x, index) => {
              try {
                const tmp = await this.getAddress(x.latitude, x.longitude)
                //
                this.$set(this.overview, index, {
                  ...x,
                  address: tmp.display_name,
                })
              } catch (err) {
                console.error(err)
                this.$set(this.overview, index, { ...x, address: '' })
              }
            })
          }
        })
        // this.loadingStop('overviews-cont')
      } catch (error) {
        console.error(error)
      }
    },
    navigateOverview() {
      this.activePeriodic = false
      // this.navigateHandler();
      this.loading_live = false
      this.activeMonitoring = false
    },
    navigatePeriodic() {
      this.activePeriodic = true
      // this.navigateHandler();
      this.loading_live = false
      this.activeMonitoring = false
    },
    navigateMonitoring() {
      this.loading_live = true
      this.activePeriodic = false
      this.activeMonitoring = true
    },
    navigateImmo() {
      this.loading_live = false
      this.activePeriodic = false
      this.activeMonitoring = false
      this.activeImmo = true
    },
    subscribe() {
      REPO.subscribeVehicle(this.id).then((res) => {
        let ref = this.reff
        ref.on(
          'value',
          function (snapshot) {
            // (snapshot.val());
          },
          function (errorObject) {
            // ("The read failed: " + errorObject.code);
          }
        )
      })
    },
    navigateHandler() {
      if (this.reff != null) this.reff.off()
      if (this.reff2 != null) this.reff2.off()
      firebase
        .auth()
        .signOut()
        .then(function () {
          // Sign-out successful.
        })
        .catch(function (error) {
          // An error happened.
        })
      REPO.unsubscribeVehicle(this.id)
    },
    closeHandler(event) {
      if (this.reff != null) this.reff.off()
      if (this.reff2 != null) this.reff2.off()
      REPO.unsubscribeVehicle(this.id)
      return 'oke ?'
    },
    startAnimation(anim_start, anim_end) {
      this.eol = this.polyline.Distance()
      this.map.setCenter(anim_start)
      let tmp_aja = this.polyline.getPath()
      // ({tmp_aja});
      this.marker = new google.maps.Marker({
        // position: this.polyline.getPath().getAt(0),
        position: anim_start,
        map: this.map,
        icon: this.icon,
      })

      this.poly2 = new google.maps.Polyline({
        // path: [this.polyline.getPath().getAt(0)],
        path: [anim_end],
        strokeColor: '#0000FF',
        strokeWeight: 10,
      })
      // map.addOverlay(poly2);
      setTimeout(() => {
        this.animate(this.lastStep)
      }, 2000) // Allow time for the initial map display
    },
    animate(d) {
      if (d > this.eol) {
        this.map.panTo(this.endLocation.latlng)
        this.marker.setPosition(this.endLocation.latlng)
        return
      }
      var p = this.polyline.GetPointAtDistance(d)
      this.map.panTo(p)
      var lastPosn = this.marker.getPosition()
      this.marker.setPosition(p)
      var heading = google.maps.geometry.spherical.computeHeading(lastPosn, p)
      // ({heading});
      this.icon.rotation = heading
      this.marker.setIcon(this.icon)
      this.updatePoly(d)
      this.timerHandle = setTimeout(() => {
        this.animate(d + this.step)
        this.lastStep = d + this.step
      }, this.tick)
    },
    updatePoly(d) {
      // Spawn a new polyline every 20 vertices, because updating a 100-vertex poly is too slow
      if (this.poly2.getPath().getLength() > 20) {
        this.poly2 = new google.maps.Polyline([
          this.polyline.getPath().getAt(this.lastVertex - 1),
        ])
        // map.addOverlay(poly2)
      }

      if (this.polyline.GetIndexAtDistance(d) < this.lastVertex + 2) {
        if (this.poly2.getPath().getLength() > 1) {
          this.poly2.getPath().removeAt(this.poly2.getPath().getLength() - 1)
        }
        this.poly2
          .getPath()
          .insertAt(
            this.poly2.getPath().getLength(),
            this.polyline.GetPointAtDistance(d)
          )
      } else {
        this.poly2
          .getPath()
          .insertAt(this.poly2.getPath().getLength(), this.endLocation.latlng)
      }
    },
    calcRoute(originAdd, endAdd, _waypoints) {
      var self = this
      if (this.timerHandle) {
        clearTimeout(this.timerHandle)
      }
      if (this.marker) {
        this.marker.setMap(null)
      }
      this.polyline.setMap(null)
      this.poly2.setMap(null)
      this.directionsDisplay.setMap(null)
      this.polyline = new google.maps.Polyline({
        path: [],
        strokeColor: '#FF0000',
        strokeWeight: 3,
      })
      this.poly2 = new google.maps.Polyline({
        path: [],
        strokeColor: '#FF0000',
        strokeWeight: 3,
      })
      // Create a renderer for directions and bind it to the map.
      var rendererOptions = {
        suppressMarkers: true,
        map: this.map,
      }
      this.directionsDisplay = new google.maps.DirectionsRenderer(
        rendererOptions
      )

      var start = new google.maps.LatLng(originAdd.lat, originAdd.lng)
      var end = new google.maps.LatLng(endAdd.lat, endAdd.lng)
      var anim_start = start
      var anim_end = end
      var waypoints = []
      if (_waypoints.length > 0) {
        _waypoints.forEach((x) => {
          let waypoint = new google.maps.LatLng(x.lat, x.lng)
          waypoints.push({
            location: waypoint,
            stopover: true,
          })
        })
        anim_start = _waypoints[_waypoints.length - 1]
        // ();
        // ({anim_start});
      }

      var travelMode = google.maps.DirectionsTravelMode.DRIVING
      // -6.2712499,106.8558403
      // -6.1371244,106.8546243
      //
      var request
      if (_waypoints.length > 0) {
        // ("waypoints");
        request = {
          origin: start,
          waypoints: waypoints,
          destination: end,
          travelMode: travelMode,
        }
        // ({waypoints});
      } else {
        // ("tanpa waypoints");
        request = {
          origin: start,
          destination: end,
          travelMode: travelMode,
        }
      }

      // Route the directions and pass the response to a
      // function to create markers for each step.
      this.directionsService.route(request, function (response, status) {
        if (status == google.maps.DirectionsStatus.OK) {
          self.directionsDisplay.setDirections(response)

          var bounds = new google.maps.LatLngBounds()
          var route = response.routes[0]
          self.startLocation = {}
          self.endLocation = {}

          // For each route, display summary information.
          var path = response.routes[0].overview_path
          var legs = response.routes[0].legs
          for (var i = 0; i < legs.length; i++) {
            if (i === 0) {
              self.startLocation.latlng = legs[i].start_location
              self.startLocation.address = legs[i].start_address
              //   marker = createMarker(legs[i].start_location, "start", legs[i].start_address, "green");
            }
            self.endLocation.latlng = legs[i].end_location
            self.endLocation.address = legs[i].end_address
            var steps = legs[i].steps
            for (var j = 0; j < steps.length; j++) {
              var nextSegment = steps[j].path
              for (var k = 0; k < nextSegment.length; k++) {
                self.polyline.getPath().push(nextSegment[k])
                bounds.extend(nextSegment[k])
              }
            }
          }
          self.polyline.setMap(self.map)
          self.map.fitBounds(bounds)
          self.map.setZoom(18)
          self.startAnimation(anim_start, anim_end)
        }
      })
    },
    initialize(map) {
      // ("init");

      this.infowindow = new google.maps.InfoWindow({
        size: new google.maps.Size(150, 50),
      })
      // Instantiate a directions service.
      this.directionsService = new google.maps.DirectionsService()

      // Create a map and center it on Manhattan.
      // var myOptions = {
      //     zoom: 13,
      //     mapTypeId: google.maps.MapTypeId.ROADMAP
      // };
      // map = new google.maps.Map(document.getElementById("map_canvas"), myOptions);
      map.setCenter(new google.maps.LatLng(-6.1498619, 106.882887))

      // Create a renderer for directions and bind it to the map.
      var rendererOptions = {
        map: map,
      }
      this.directionsDisplay = new google.maps.DirectionsRenderer(
        rendererOptions
      )

      // Instantiate an info window to hold step text.
      this.stepDisplay = new google.maps.InfoWindow()

      this.polyline = new google.maps.Polyline({
        path: [],
        strokeColor: '#FF0000',
        strokeWeight: 3,
      })
      this.poly2 = new google.maps.Polyline({
        path: [],
        strokeColor: '#FF0000',
        strokeWeight: 3,
      })
      // this.calcRoute(this.location_list[0], this.location_list[0], []);
      // setTimeout(()=>{
      //     this.calcRoute(this.location_list[0], this.location_list[1], []);
      // },5000);
      // setTimeout(()=>{
      //     let tmp=[];
      //     tmp.push(this.location_list[1]);
      //     this.calcRoute(this.location_list[0], this.location_list[2], tmp);
      // },17000)

      // setTimeout(()=>{
      //     this.animate(this.lastStep);
      // },15000)
    },
    createMarker(latlng, label, html) {
      var contentString = '<b>' + label + '</b><br>' + html
      var marker = new google.maps.Marker({
        position: latlng,
        map: this.map,
        title: label,
        zIndex: Math.round(latlng.lat() * -100000) << 5,
      })
      this.marker.myname = label
      google.maps.event.addListener(marker, 'click', () => {
        this.infowindow.setContent(contentString)
        this.infowindow.open(this.map, marker)
      })
      return marker
    },
    signInFirebase() {
      firebase
        .auth()
        .signInAnonymously()
        .catch(function (error) {
          // (error);
        })
    },
  },

  mounted() {
    let self = this
    let id = this.$route.params.id
    this.setHeaderHidden()

    // this.vehicle_id = id
    let role = JSON.parse(localStorage.getItem('userInfo')).role.role_menu
    //
    let url = this.$router.currentRoute.path
    let check = role.filter((x) => {
      return url.substring(0, 20) === x.menu_link
    })
    //
    if (check.length > 0) {
      if (check[0].is_update == 1) {
        this.activeImo = true
      }
    }
    this.activeImo = false
    //

    //

    REPO.getOneMWMapping(id, 'vehicle_id').then((rress) => {
      self.infoBoxOpen = true
      self.$vs.loading.close()

      // this.loadingStart('overviews-cont')
      // this.loadingStart('info-vehicle')

      const tmp = rress.data.data
      REPO.getOneVehicle(id).then((res) => {
        const tmp2 = res.data.data
        this.vehicle_id = tmp2.id
        this.vehicle_category = tmp2.vehicle_category
        this.dashcam = tmp2.dashcam
        this.temperature_module = tmp2.temperature_module
        //
      })

      self.selectedLocation = tmp

      this.id = tmp.vin
      this.license_plate = tmp.license_plate
      this.simcard_number = tmp.simcard_number

      setTimeout(() => {
        this.getOverview()
      }, 500)

      this.isMounted = true
      REPO.getListAlert().then((res) => {
        let tmp = res.data.data
        this.event_list = [{ text: 'All', value: '' }]
        tmp.forEach((x) => {
          this.event_list.push({ text: x.alert_name, value: x.alert_code })
        })
      })
    })

    this.$root.$on('goToTimeline', (tr) => {
      this.tabIndex = 4

      setTimeout(() => {
        this.$root.$emit('populateFromParent', tr)
      }, 1000)
    })

    // this.$root.$on('setSidebarData', (trip) => {
    //
    // })
  },
}
</script>

<style lang="scss">
.overviewbg {
  background: rgb(239, 239, 239);
}

.vs-card--content {
  margin: 0;
}

@keyframes flickerAnimation {
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

@-o-keyframes flickerAnimation {
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

@-moz-keyframes flickerAnimation {
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

@-webkit-keyframes flickerAnimation {
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

.loader_1 {
  border: 5px solid #f3f3f3;
  border-radius: 50%;
  border-top: 5px solid #3498db;
  width: 25px;
  height: 25px;
  -webkit-animation: spin 2s linear infinite;
  /* Safari */
  animation: spin 2s linear infinite;
}

.animate-flicker {
  text-align: center;
  font-size: 11px;
  animation-delay: 2s;
  -webkit-animation-delay: 2s;
  -moz-animation-delay: 2s;
  -o-animation-delay: 2s;
  animation-iteration-count: 5;
  -webkit-animation-iteration-count: 5;
  -moz-animation-iteration-count: 5;
  -o-animation-iteration-count: 5;
  animation-duration: 1s;
  -webkit-animation-duration: 1s;
  -moz-animation-duration: 1s;
  -o-animation-duration: 1s;
  -webkit-animation-name: flickerAnimation;
  -moz-animation-name: flickerAnimation;
  -o-animation-name: flickerAnimation;
  animation-name: flickerAnimation;
}

.box-vehicle {
  cursor: pointer;
  position: relative;
  display: inline-block;
  /*outline:2px solid #DDD;*/
  /*border:#a1a1a1;*/
  /*background-color: #fff;*/
  border-radius: 5px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0);
  -webkit-transition: all 0.6s cubic-bezier(0.165, 0.84, 0.44, 1);
  transition: all 0.6s cubic-bezier(0.165, 0.84, 0.44, 1);
}

.box-vehicle::after {
  content: '';
  border-radius: 5px;
  position: absolute;
  z-index: -1;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
  opacity: 0;
  -webkit-transition: all 0.6s cubic-bezier(0.165, 0.84, 0.44, 1);
  transition: all 0.6s cubic-bezier(0.165, 0.84, 0.44, 1);
}

.box-vehicle:hover {
  -webkit-transform: scale(1.15, 1.15);
  transform: scale(1.15, 1.15);
}

.box-vehicle:hover::after {
  opacity: 1;
}

#data-list-list-view {
  .vs-con-table {
    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;

      >span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);

        td {
          padding: 20px;

          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }

          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }

        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }

      th.td-check {
        padding: 0 15px !important;
      }

      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>

<style lang="scss">
.con-vs-loading {
  z-index: 10;
}

.window-monitoring {
  box-shadow: #0000005c 1px 0px 6px;
  padding: 18px 0;
  position: absolute;
  z-index: 3;
  background: white;
  font-size: 12px;
}

.heights {
  width: 100%;
  height: calc(100vh - 15.1rem);
}
</style>